
import { getFileFromUrl } from '@/api';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { notificationErrorText } from '@/utils/PortalConstants';

@Component({})
export default class Button extends Vue {
  @Prop({ type: String, required: false, default: '#' }) public link!: string;
  @Prop({ type: String, required: false, default: 'Download' }) public text!: string;

  private downloadFile(link): void {
    const fileName = link.substring(link.lastIndexOf('/') + 1);
    getFileFromUrl(link)
      .then(res => {
        const blob = new Blob([res]);
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = fileName;
        downloadLink.click();
        URL.revokeObjectURL(downloadLink.href);
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          title: 'Error downloading the file',
          text: notificationErrorText,
          type: 'warn',
        });
      });
  }
}
